import { createContext, useContext } from "react";

/**
 * Whether choosing a row in a people picker puts that person on a vendor team as a member.
 *
 * Nobody joins a vendor team as a member until their profile lists their professional credentials
 * (#5800): they are the people who bill the client, and a client can reject charges from somebody
 * whose credentials it never saw. So a picker that seats its choice there declines the people the
 * team would refuse, and says why. The same picker also chooses a leader, who is not held to it; a
 * client team's in-house colleagues, who bill nobody; and who bills a fee schedule template's rate,
 * which seats nobody. Like `RowChoiceLabel`, the host says which, and the context carries it to
 * every tab at once, including the marketplace's results four components below.
 *
 * False unless a host says otherwise, so a picker nobody has thought about refuses nobody: the API
 * still decides when the team is saved.
 */
export const RowChoiceRequiresCredentials = createContext(false);

export function useRowChoiceRequiresCredentials(): boolean {
  return useContext(RowChoiceRequiresCredentials);
}
